import { lazyLoad } from 'utils/loadable';

export const ProductionPredictionPage = lazyLoad(
  () => import('app/components/pages/ProductionPredictionPage/index'),
  (module) => module.ProductionPredictionPage,
);
